export type MediaCacheProgressState = "queued" | "active" | "done" | "failed"

export type MediaCacheProgress = {
  key: string
  received: number
  total: number | null
  state: MediaCacheProgressState
}

const STATES: readonly MediaCacheProgressState[] = ["queued", "active", "done", "failed"]

export function isMediaCacheProgress(value: unknown): value is MediaCacheProgress {
  if (!value || typeof value !== "object") return false
  const row = value as Partial<MediaCacheProgress>
  if (typeof row.key !== "string" || row.key.length === 0) return false
  if (typeof row.received !== "number" || !Number.isFinite(row.received)) return false
  if (row.total != null && (typeof row.total !== "number" || !Number.isFinite(row.total))) return false
  return typeof row.state === "string" && STATES.includes(row.state as MediaCacheProgressState)
}

export function applyMediaCacheProgress(
  items: ReadonlyMap<string, MediaCacheProgress>,
  event: MediaCacheProgress,
): Map<string, MediaCacheProgress> {
  const next = new Map(items)
  if (event.state === "done" || event.state === "failed") next.delete(event.key)
  else next.set(event.key, event)
  return next
}

/** Furthest active download, 1–100. Null while queued or before the first percent. */
export function mediaCacheChipPercent(items: Iterable<MediaCacheProgress>): number | null {
  let best: number | null = null
  for (const item of items) {
    if (item.state !== "active" || item.total == null || item.total <= 0) continue
    const pct = Math.min(100, Math.floor((item.received / item.total) * 100))
    if (pct <= 0) continue
    if (best == null || pct > best) best = pct
  }
  return best
}

export function mediaCacheChipVisible(items: Iterable<MediaCacheProgress>): boolean {
  for (const item of items) {
    if (item.state === "queued" || item.state === "active") return true
  }
  return false
}
